import { useQuery } from '@tanstack/react-query';

import CustomerService from '@/services/CustomerService';

export const VERIFY_CREATE_NAME_MODEL_QUERY_KEY = ['verifyCreateNameModel'];

export function useVerifyCreateNameModel() {
  const { data, isFetching } = useQuery({
    queryKey: VERIFY_CREATE_NAME_MODEL_QUERY_KEY,
    queryFn: () => CustomerService.verifyCreateNameModel(),
  });

  return {
    hasModel: data,
    isLoading: isFetching,
  };
}
